export default "__VITE_ASSET__G2sZyW10__"